import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { RootState } from '@redux/store';

interface IState {
  data: any;
}
const initialState: IState = {
  data: {
    itemCount: 0,
    loadingCompare: false,
  },
};

export const compareSlice = createSlice({
  name: 'compare',
  initialState,
  reducers: {
    setInitCompare: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.data.loadingCompare = true;
    },
    setAdd: state => {
      // state.data.items = [ ...state.data.items, action.payload]
      state.data.totalItems += 1;
    },
    setDelete: state => {
      // let list = state.data.items.filter(item => item !== action.payload)
      // state.data.items = list
      state.data.totalItems -= 1;
    },
  },
  extraReducers: {
    [HYDRATE]: (state, action) => {
      return {
        ...state,
        ...action.payload.compare,
      };
    },
  },
});

export const { setInitCompare, setAdd, setDelete } = compareSlice.actions;

export const selectCompareData = (state: RootState) => state.compare.data;

export const compareReducer = compareSlice.reducer;
